import { Router } from '@angular/router';
import { first } from 'rxjs';

import { appInject } from 'src/app/app-injector';
import { OWCC_QUERY_PARAM } from 'src/app/core/config/query-params.config';
import { LinkService } from 'src/app/core/services/link/link.service';

import { noop } from './noop';

export const goToSummary = (vehicleId: string): void => {
  const linkService = appInject<LinkService>(LinkService);
  const router = appInject<Router>(Router);
  linkService
    .getConfigurationSummaryLink(vehicleId)
    .pipe(first())
    .subscribe(link => {
      router.navigate([link], { queryParams: { [OWCC_QUERY_PARAM.VEHICLE_ID]: null } }).catch(noop);
    });
};
